import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import Industries from "../pages/industries/page";
import CaseStudies from "../pages/case-studies/page";
import Contact from "../pages/contact/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/industries", element: <Industries /> },
  { path: "/case-studies", element: <CaseStudies /> },
  { path: "/contact", element: <Contact /> },
  { path: "*", element: <NotFound /> },
];

export default routes;
